<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
       
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("wa_master_phone_number") }}</h4>
                   
                    <button
                      v-if="this.permision_role.method_create"
                      class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="createData()"
                    >
                      <i class="link-icon" data-feather="plus"></i>
                      {{ $t("createNew") }}
                    </button>

                    <button
                      v-if="this.permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="downloadData()"
                    >
                       <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                  </div>
  
                  <div class="card-body">
                    <vue-good-table
                      mode="remote"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns"
                    > 
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                            
                           <a
                                href="#"
                                v-if="permision_role.method_read"
                                title="Detail"
                                @click.prevent="
                                  detailData(props.index, props.row)
                                "
                              >
                                <i class="mdi mdi-eye" style="font-size:16px"></i>
                                
                              </a>
                              <a
                                href="#"
                                v-if="permision_role.method_update"
                                title="Edit"
                                @click.prevent="editData(props.index, props.row)"
                              >
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                                
                              </a>
                              
                              <a
                                href="#"
                                v-if="permision_role.method_delete"
                                title="Delete"
                                @click.prevent="
                                  deleteData(props.index, props.row)
                                "
                              >
                                <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                              </a>
  
                             
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
  
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "MasterPhoneNumberIndex",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        maxToasts: 100,
        company_types:[],
        position: "up right",
        closeBtn: true,
        isLoading: false,
        permision_role:[],
        errors: [],
        langs: ["id", "en"],
        detailUser: [],
        detailDivisi: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
        columns: [
          {
            label: this.$t("master_phone_number_id"),
            field: "master_phone_number_id",
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("master_phone_number_id"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("phone_number"),
            field: "phone_number",
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("phone_number"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("phone_name"),
            field: "phone_name",
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("phone_name"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
         
          {
            label: "Status",
            field: "status",
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("status_filter_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: ["active", "deactived"], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
         
         {
           label: this.$t("waStatus"),
           field: "waStatus",
           filterOptions: {
             enabled: true, // enable filter for this column
             placeholder: this.$t("waStatus"), // placeholder for filter input
             filterValue: "", // initial populated value for this filter
             filterDropdownItems: ["connected", "disconnected"], // dropdown (with selected values) instead of text input
             trigger: "enter", //only trigger on enter not on keyup
           },
         },
          {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
          },
        ],
        rows: [],
      };
    },
    watch: {},
    methods: {
  
      downloadData() {
        const baseURI = this.$settings.endPointWhatsapp + "api/dashboard/master-phone-number";
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
  
        return this.$http
          .get(
            baseURI +
              `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&phone_number=${this.serverParams.columnFilters.phone_number}&phone_name=${this.serverParams.columnFilters.phone_name}&status=${this.serverParams.columnFilters.status}&master_phone_number_id=${this.serverParams.columnFilters.master_phone_number_id}&download=download`,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
  
   
      createData() {
        window.location.href = "/whatsapp/master-phone-number/create";
      },
  
      editData(index, row) {
        var params = this.$onRandom(row.master_phone_number_id);
        window.location.href = "/whatsapp/master-phone-number/edit/" + params;
      },
  
      detailData(index, row) {
        var params = this.$onRandom(row.master_phone_number_id);
        window.location.href = "/whatsapp/master-phone-number/detail/" + params;
      },
  
      deleteData(index, row) {
        this.$swal({
          title: this.$t("areYouSure"),
          text: status,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            
            const baseURI = this.$settings.endPointWhatsapp + "api/dashboard/master-phone-number/delete/" + row.master_phone_number_id;
            this.$http
              .delete(baseURI,{ timeout: 10000 })
              .then((response) => {
                this.loading();
                if (response.data.status === 200) {
                  this.success(response.data.datas.messages);
                  this.loadItems();
                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              })
              .catch((error) => {
                this.loading();
                if(error.code == "ECONNABORTED"){
                  this.error(this.$t("check_internet_connection_txt"));
                  
                }else{
  
                   if (error.response) {
                      if(error.response.status === 422) {
                              this.errors = error.response.data.errors;
                              this.resultError(error.response.data.errors);
                      }else if (error.response.status === 401) {
                          this.logout();
                      } else if (error.response.status === 403) {
                          this.$router.push("/authorized-error");
                      }else if (error.response.status === 500) {
                          this.$router.push('/server-error');
                      }else{
                          this.$router.push('/page-not-found');
                      }
                  }
  
                }
              });
          }else{
            this.isLoading = false;
          }
        });
      },
  
      logout(){

        const baseURI = this.$settings.endPoint + "user/logout";
        this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
            
        console.log(response);

        });

        this.$logoutUser();
        window.location.href = '/';
      },

      // load items is what brings back the rows from server
      loadItems() {
        const baseURI = this.$settings.endPointWhatsapp + "api/dashboard/master-phone-number";
 
        this.isLoading = true;
        return this.$http
          .get(
            baseURI +
              `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&phone_number=${this.serverParams.columnFilters.phone_number}&phone_name=${this.serverParams.columnFilters.phone_name}&status=${this.serverParams.columnFilters.status}&master_phone_number_id=${this.serverParams.columnFilters.master_phone_number_id}`,
               {timeout: 10000 }
          )
          .then((response) => {
            this.rows = response.data.datas.data;
            this.totalRecords = response.data.datas.total;
            this.isLoading = false;
          }).catch(error => {
            this.isLoading = false;
             
            if(error.code == "ECONNABORTED"){
              this.error(this.$t("check_internet_connection_txt"));
            }else{
  
               if (error.response) {
                  if(error.response.status === 422) {
                          this.errors = error.response.data.errors;
                          this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
              }
  
            }
  
          });
      },
  
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.loadItems();
      },
  
      onColumnFilter(params) {
        this.updateParams(params);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
      },
  
      onPerPageChange(params) {
        this.updateParams({ per_page: params.currentPerPage });
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.isLoading = false;
        }, 1000); // hide the message after 3 seconds
      },
  
      fetchIt() {
        const userDatas     = this.$getUserInfo();
        this.detailUser     = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function(permision){
          if(permision.permission.controller == 'WaMasterPhoneNumberController'){
            rolePermision = permision;
            // console.log(permision);
          }
        });
  
        if(!rolePermision.method_read){
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
        var status = this.$route.query.status
        if(status == "200"){
          this.success(this.$route.query.msg)
        }
  
      },
   
       
  
    },
    events: {},
    created: function () {},
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  </style>